(function ($) {
    $(function () {
        let buttonClass = 'button-input';

        $('.filter-section--size').slideUp();
        $('.product-filter__wrap .button--shop').slideUp();

        $('.product-filter .filter-section--use .single-filter').on('click', function() {
            event.preventDefault();

            document.getElementById('product-filters').scrollIntoView({
                behavior: 'smooth'
            });

            var tax_name = this.getElementsByClassName(buttonClass)[0].dataset.suitable;
            var product_size = '';
            var nice_tax_name = this.getElementsByClassName(buttonClass)[0].textContent.toLowerCase();

            $('.filter-section--use').each(function () {
                $(this).find('.single-filter > .' + buttonClass).removeClass('button-input--active');
            });

            $(this).find('> .' + buttonClass).addClass('button-input--active');

            $('.filter-section--size').slideDown();
            $('.filter-section__name').text(nice_tax_name);

            $('.filter-section--size .single-filter').on('click', function () {
                event.preventDefault();

                $('.filter-section--size').each(function () {
                    $(this).find('.single-filter > .' + buttonClass).removeClass('button-input--active');
                });

                $(this).find('> .' + buttonClass).addClass('button-input--active');

                var button = $('.product-filter__wrap .button-input--shop');
                var product_size = $(this).find('> .' + buttonClass).text();

                button.slideDown();
                button.attr('href', '/buy-online/products/?yith_wcan=1&suitable=' + tax_name + product_size.toLowerCase());
            })
        })
    });
})(jQuery);